<template>
  <v-progress-circular
  v-show="apiInAction"
  class="api-in-action" :size="20" :width="1" indeterminate
  :color="color"
  ></v-progress-circular>
</template>

<script>
export default {
  name: 'api-activity-indicator',
  props: ['color'],
  computed: {
    apiInAction () {
      return this.$store.state.tasksInAction > 0
    }
  }
}
</script>

<style lang="css">
.api-in-action {
 position: fixed;
 right: 7px;
 top: 66px;
 z-index: 3;
}
</style>
